var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 40.5",
    style: {
      enableBackground: "new 0 0 45 40.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,1.1c-3.2-1.5-6.8-1.5-10,0L2.5,8.2C0,9.3-0.6,12.5,0.6,14.7v11.1c0,0.9,0.8,1.7,1.7,1.7 s1.7-0.8,1.7-1.7v-8.6l13.6,6.4c3.2,1.5,6.8,1.5,10,0l15.1-7.1c3.3-1.5,3.3-6.9,0-8.4L27.5,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,22.3v8.4c0,2.3,1.1,4.4,3.1,5.5c3.3,1.8,8.6,4.3,12.6,4.3s9.3-2.5,12.6-4.3c2-1.1,3.1-3.2,3.1-5.5v-8.4 l-9.3,4.4c-4.1,1.9-8.7,1.9-12.8,0C16.1,26.7,6.8,22.3,6.8,22.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.b5abf669d917fbc23fa77be4f8567df7.svg";
export { ForwardRef as ReactComponent };